import ngStorage from '../../common/wrappers/ngstorage';
import resResourceMod from '../common/resources/reservation.resource';
import {noop} from "./common.utils";
import keepaliveServiceMod from './keepalive/keepalive.service';
import maintenanceStripeComponentMod from './keepalive/maintenance-stripe.component';
import {BOTTOM_MESSAGES_DOM_ID} from './bottom-messages.constants';
import browserErrorComponentMod from './components/browser-error.component';
import translationServiceMod from './translation.service';

function runCheckTemporaries($sessionStorage, $log, ReservationResource) {
  'ngInject';

  if ($sessionStorage.deleteTemporaries === 'true') {
    $log.debug("Sessionstorage deleteTemporaries == true, run delete");
    delete $sessionStorage.deleteTemporaries;
    ReservationResource.cancelTemporaries().catch(noop);
  }
}

runCheckTemporaries.imports = [ngStorage, resResourceMod];


/**
 * Show maintenance stripe on every page when maintenance mode is turned on to remind people that it is turned on.
 */
function showMaintenanceStripe($compile, $rootScope, $timeout, KeepaliveService, TranslationService) {
  'ngInject';

  let stripe_shown = false;

  const stripe_scope = $rootScope.$new(true);

  TranslationService.waitForTranslations().then(() => {
    KeepaliveService.subscribeMaintenance(status => {
      $timeout(() => {
        if (status === true) {
          // On first run, set stripe
          if (!stripe_shown) {
            stripe_scope.maintenanceEnd = KeepaliveService.maintenanceEnd;

            const element = document.getElementById(BOTTOM_MESSAGES_DOM_ID);
            const ng_element = angular.element('<maintenance-stripe end-time="maintenanceEnd"></maintenance-stripe>');

            $compile(ng_element)(stripe_scope);
            angular.element(element).append(ng_element);

            stripe_shown = true;
          }

          // On future runs (when more detailed information arrives from backend), update maintenanceEnd
          else {
            stripe_scope.maintenanceEnd = KeepaliveService.maintenanceEnd;
          }
        }
      });
    });
  });
}
showMaintenanceStripe.imports = [keepaliveServiceMod, maintenanceStripeComponentMod, translationServiceMod];


/**
 * Show maintenance stripe on every page when maintenance mode is turned on to remind people that it is turned on.
 */
function showIeError($compile, $rootScope, $log, $timeout, $document, TranslationService) {
  'ngInject';

  TranslationService.waitForTranslations().then(() => {

      if (Function('/*@cc_on return document.documentMode===10@*/')()) {
        $log.warn("Using unsupported browser: IE 10");

        const error_scope = $rootScope.$new(true);

        const element = document.getElementById(BOTTOM_MESSAGES_DOM_ID);
        const ng_element = angular.element('<browser-error-stripe browser="Internet Explorer 10"></browser-error-stripe>');

        $compile(ng_element)(error_scope);
        angular.element(element).append(ng_element);
      }
  });
}
showIeError.imports = [browserErrorComponentMod, translationServiceMod];


export {
  runCheckTemporaries,
  showMaintenanceStripe,
  showIeError,
};
